"use client";

import { createContext, useContext } from "react";

export type StoreContact = {
  /** Digits wa.me accepts, or null when the store has no usable number. */
  whatsappPhone: string | null;
  storeName: string | null;
};

/**
 * The store's public WhatsApp number, for the two customer-initiated entry
 * points — "ask about this product" on the PDP and the floating help bubble.
 * Same provider shape as StockDisplayProvider, resolved once in the storefront
 * layout so neither surface has to re-read brand config.
 *
 * Null phone is the off switch: both entry points render nothing rather than
 * offering a link that goes nowhere.
 */
const StoreContactContext = createContext<StoreContact>({
  whatsappPhone: null,
  storeName: null,
});

export function StoreContactProvider({
  value,
  children,
}: {
  value: StoreContact;
  children: React.ReactNode;
}) {
  return (
    <StoreContactContext.Provider value={value}>
      {children}
    </StoreContactContext.Provider>
  );
}

export function useStoreContact(): StoreContact {
  return useContext(StoreContactContext);
}
